import SlideManager from "../utils/slide-manager";
import { listen, fire } from "../utils/events";
import AssetLibrary from "./asset-library";

const AssetsBusy = (function () {
    /**
     * @type {Object<number, ActiveQueue>}
     */
    const assets = {};
    let spinner = null;

    function findSpinner() {
        spinner = spinner || document.getElementById("qbix-viewer-button-play");

        return !!spinner;
    }

    return new class AssetsBusy {
        constructor() {
            listen("enterslide", slideIndex => this.checkSpinner(slideIndex));
        }

        isSlideReady(index = SlideManager.activeSlide) {
            const slide = SlideManager.getSlide(index);

            if (slide && slide.visible === false) return true;

            const hasQueue = AssetLibrary.assetQueues.find(x => x.slideIndex === index) >= 0;

            if (hasQueue) return true;

            return assets[index] && assets[index].isReady;
        }

        hasQueueLOD(index = SlideManager.activeSlide) {
            const slide = SlideManager.getSlide(index);

            if (!slide) return false;

            return !!AssetLibrary.assetQueuesLOD.find(x => x.slideIndex === index);
        }

        checkSpinner(slideIndex = SlideManager.activeSlide) {
            if (!Q3.editMode && slideIndex === SlideManager.activeSlide) {
                if (findSpinner()) {
                    if (this.isSlideReady(slideIndex) && !this.hasQueueLOD(slideIndex))
                        spinner.classList.remove("waiting");
                    else spinner.classList.add("waiting");
                }
            }
        }

        register({ slide, promise }) {
            const queue = assets[slide] = assets[slide] || new ActiveQueue(slide);

            queue.register(promise);
            queue.init();

            this.checkSpinner(slide);
        }
    }
})();

export default AssetsBusy;
export { AssetsBusy };

class ActiveQueue {
    constructor(slideIndex) {
        this.slideIndex = slideIndex;
        this.activePromise = null;
        this.promises = [];
        this.isReady = true;
    }

    register(promise) { this.promises.push(promise); }

    init() {
        this.isReady = false;

        let promise;

        const fnlly = () => {
            console.log("Assets loaded:", this.slideIndex + 1);

            if (this.activePromise !== promise) {
                console.log("Canceled promise:", this.slideIndex);
                return;
            }

            while (this.promises.pop()) { }

            this.isReady = true;
            this.activePromise = null;

            if (this.slideIndex === SlideManager.activeSlide) {
                if (Q3.editMode || Q3.isAssetMode)
                    fire("commit_slide");
            } else console.log("Could not commit to slide:", this.slideIndex + 1, SlideManager.activeSlide + 1);

            fire("slide_ready", this.slideIndex);

            AssetsBusy.checkSpinner(this.slideIndex);
        };

        promise = Promise.all(this.promises).then(() => {
            fnlly();
        }).catch((error) => {
            console.error(error);
            fnlly();
        });
        this.activePromise = promise;

    }
}